function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z",
  stroke: "#8E8E93",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.4375 17.5C13.4375 18.2939 12.7939 18.9375 12 18.9375C11.2061 18.9375 10.5625 18.2939 10.5625 17.5C10.5625 16.7061 11.2061 16.0625 12 16.0625C12.7939 16.0625 13.4375 16.7061 13.4375 17.5Z",
  fill: "#8E8E93",
  stroke: "#8E8E93",
  strokeWidth: 0.125
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12 14V13.2222C12.5933 13.2222 13.1734 13.0398 13.6667 12.6979C14.1601 12.3561 14.5446 11.8702 14.7716 11.3017C14.9987 10.7332 15.0581 10.1077 14.9424 9.50416C14.8266 8.90067 14.5409 8.34632 14.1213 7.91122C13.7018 7.47613 13.1672 7.17982 12.5853 7.05978C12.0033 6.93974 11.4001 7.00135 10.8519 7.23682C10.3038 7.47229 9.83524 7.87105 9.50559 8.38267C9.17595 8.89429 9 9.49579 9 10.1111",
  stroke: "#8E8E93",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgTooltip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.fd961298.svg";
export { ForwardRef as ReactComponent };